import {ViewController} from "data/types/structure";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {Bindings} from "data/constants/bindings";
import {ALLOWED_LANGUAGES} from "data/constants";
import {changeRouteLanguage, getLanguageFromPath} from "data/utils/language";
import RallySSO from "data/utils/SSO/rallySSO";
import {createFanHubEvent, EventGUID} from "data/utils/analytics";
import type {IGeoStore} from "data/stores/geo/geo.store";

export interface IHeaderController extends ViewController {
	readonly i18n: ILocalizationStore;
	get currentLanguage(): string;
	get secondLanguage(): string;
	get isNative(): boolean;
	get logoURL(): string | null;

	languageToggle: () => void;
}

@injectable()
export class HeaderController implements IHeaderController {
	@observable private _isNative: boolean = RallySSO.IS_NATIVE;
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.GeoStore) public readonly _geoStore: IGeoStore
	) {
		makeAutoObservable(this);
	}

	get currentLanguage() {
		return !ALLOWED_LANGUAGES.includes(getLanguageFromPath()) || getLanguageFromPath() === "en"
			? "en"
			: "es";
	}

	get secondLanguage() {
		return !ALLOWED_LANGUAGES.includes(getLanguageFromPath()) || getLanguageFromPath() === "en"
			? "es"
			: "en";
	}

	get isNative() {
		return this._isNative;
	}

	get logoURL() {
		console.log(this._geoStore.geo);
		return this._geoStore.geo?.logoLight || null;
	}

	public languageToggle = () => {
		const newLanguage = this.currentLanguage === "es" ? "en" : "es";
		createFanHubEvent(EventGUID.LanguageChangeClick);
		changeRouteLanguage(this.currentLanguage, newLanguage);
	};
}
